module.exports = __webpack_public_path__ + "img/ham.01e6d855.svg";